._TextEqual_19z3a_1 {
  width: 100%;
}